import React from "react";
import { Routes, Route } from "react-router-dom";

import RoutePublic from "./RoutePublic";
import RoutePrivate from "./RoutePrivate";

import HomeFranqueados from "../pages/Home";
import Login from "../pages/Login";
import ResetPassword from "../pages/ResetPassword";
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import Nutritions from "../pages/Nutrition";
import NutritionForm from "../pages/Nutrition/form";
import Exercises from "../pages/Exercises";
import ExerciseForm from "../pages/Exercises/form";
import Articles from "../pages/Articles";
import ArticleForm from "../pages/Articles/form";
import Insights from "../pages/Insights";
import InsightForm from "../pages/Insights/form";
import Notifications from "../pages/Notifications";
import Payments from "../pages/Payments";

const Routers = () => {
  return (
    <Routes>
      <Route exact path="*" element={<RoutePublic />}>
        <Route exact path="*" element={<Login />} />
      </Route>
      <Route exact path="/resetpassword" element={<RoutePublic />}>
        <Route exact path="/resetpassword" element={<ResetPassword />} />
      </Route>
      <Route exact path="/" element={<RoutePrivate />}>
        <Route exact path="/" element={<HomeFranqueados />} />
      </Route>
      <Route exact path="/profile" element={<RoutePrivate />}>
        <Route exact path="/profile" element={<Profile />} />
      </Route>
      <Route exact path="/users" element={<RoutePrivate />}>
        <Route exact path="/users" element={<Users />} />
      </Route>
      <Route exact path="/payments" element={<RoutePrivate />}>
        <Route exact path="/payments" element={<Payments />} />
      </Route>

      {/* Tips Routes */}
      <Route exact path="/insights" element={<RoutePrivate />}>
        <Route exact path="/insights" element={<Insights />} />
      </Route>
      <Route exact path="/insights/new" element={<RoutePrivate />}>
        <Route exact path="/insights/new" element={<InsightForm />} />
      </Route>
      <Route exact path="/insights/edit/:id" element={<RoutePrivate />}>
        <Route exact path="/insights/edit/:id" element={<InsightForm />} />
      </Route>

      {/* Notifications Routes */}
      <Route exact path="/notifications" element={<RoutePrivate />}>
        <Route exact path="/notifications" element={<Notifications />} />
      </Route>

      {/* Recipes Routes */}
      <Route exact path="/nutritions" element={<RoutePrivate />}>
        <Route exact path="/nutritions" element={<Nutritions />} />
      </Route>
      <Route exact path="/nutritions/new" element={<RoutePrivate />}>
        <Route exact path="/nutritions/new" element={<NutritionForm />} />
      </Route>
      <Route exact path="/nutritions/edit/:id" element={<RoutePrivate />}>
        <Route exact path="/nutritions/edit/:id" element={<NutritionForm />} />
      </Route>

      {/* Exercises Routes */}
      <Route exact path="/exercises" element={<RoutePrivate />}>
        <Route exact path="/exercises" element={<Exercises />} />
      </Route>
      <Route exact path="/exercises/new" element={<RoutePrivate />}>
        <Route exact path="/exercises/new" element={<ExerciseForm />} />
      </Route>
      <Route exact path="/exercises/edit/:id" element={<RoutePrivate />}>
        <Route exact path="/exercises/edit/:id" element={<ExerciseForm />} />
      </Route>

      {/* Articles Routes */}
      <Route exact path="/articles" element={<RoutePrivate />}>
        <Route exact path="/articles" element={<Articles />} />
      </Route>
      <Route exact path="/articles/new" element={<RoutePrivate />}>
        <Route exact path="/articles/new" element={<ArticleForm />} />
      </Route>
      <Route exact path="/articles/edit/:id" element={<RoutePrivate />}>
        <Route exact path="/articles/edit/:id" element={<ArticleForm />} />
      </Route>
    </Routes>
  );
};

export default Routers;
